import { useEffect } from 'react'

export function useTheme() {
  // On branded (/u/:realm) pages, branding hook manages the theme — skip here
  const isBranded = /^\/u\//.test(window.location.pathname)

  // Always use system theme
  useEffect(() => {
    if (isBranded) return
    const html = document.documentElement
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    html.classList.toggle('dark', prefersDark)
    
    // Listen to system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = (e: MediaQueryListEvent) => {
      document.documentElement.classList.toggle('dark', e.matches)
    }

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [isBranded])

  return { theme: 'system' as const }
}
